import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDLabelText, FDTitleText } from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride(['subTitle', 'subtitle'], {
    _component: () => FDLabelText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDTitleText,
  }, overrideReadOnly);
